import { post, transformRequestData } from "./utils/requests"

interface IData {
  campId: string
  campingStyleId: string
  bookingIntervalId?: string
  startDate: string
  endDate: string
}

interface IForDatesResponse {
  unavailable_dates?: string[]
  unavailable_interval_dates?: {
    date: string
    intervals: {
      id: string
      name: string
    }[]
  }[]
}

const forDates = (data: IData): Promise<IForDatesResponse> =>
  post('/api/date_availabilities', transformRequestData(data))

const DateAvailabilities = {
  forDates
}

export default DateAvailabilities
